module.exports = __webpack_public_path__ + "static/media/file_reset_icon.2480b09b.svg";